export enum Role {
    USER = 'ROLE_USER',
    ADMIN = 'ROLE_ADMIN',
    MANAGER = 'ROLE_MANAGER'
}

export type UserDto = {
    id: number;
    profileId: number;
    email: string;
    roles: Role[];
};
